import React from 'react';
import { Link } from 'react-router-dom';

import moment from 'moment';

import * as MESSAGES from 'Lib/Messages';
import Notification from 'Components/UI_Library/Notification/Notification';
import InputError from 'Components/UI_Library/FormElements/InputError';
import Validator from 'Lib/Validator';
import Config from '../../../../Config';
import classes from './SignUpPage.module.css';
import { BackendAccessContext } from 'Backend';
import MobileCountrySelector from 'Components/UI_Library/FormElements/MobileCountrySelector';
import AuthPageWrapper from 'Components/Auth/AuthPageWrapper/AuthPageWrapper';
import Button from 'Components/UI_Library/FormElements/Button';
import TextInput from 'Components/UI_Library/FormElements/TextInput';
import { withRouter } from 'Lib/withRouter';

import { toLowerCaseSafe } from 'Lib/Utils';
import { validateEmail } from 'Backend/users/validateEmail';
import Tooltip from 'Components/UI_Library/Tooltip/Tooltip';
import { passwordTooltipText } from 'Components/SignIn/utils/passwordTooltipText';

class UserSignUp extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            code: '',
            term: true,
            loading: false,
            errors: {},
            isError: false,
            errorMessage: null,
            isShowPassword: false,
            isShowPasswordConfirm: false,
            country: { name: 'Australia', code: 'AU', countryCode: '+61' },
            mobile: '',
            keypay: false,
            oAuthLogin: false,
        };
        const searchParams = new URLSearchParams(window.location.search);
        const clientId = searchParams.get('clientId');
        const authFlow = searchParams.get('authFlow');
        if (clientId) {
            this.state.oAuthLogin = true;
        }
        if (authFlow) {
            this.state.authFlow = authFlow;
        }
        //KeyPay ClientID for switching branding
        if (clientId === Config.keypay_client_id) {
            this.state.keypay = true;
        }
        this.state = { ...this.getInitialState(), ...this.state };
        this.inputAutoFocusRef = React.createRef();
        this.standardInputAutoFocusRef = React.createRef();
    }

    static contextType = BackendAccessContext;

    getInitialState = () => ({
        password: '',
        confirmPassword: '',
        user: {
            Id: '',
            FirstName: '',
            LastName: '',
            CompanyName: '',
            Email: '',
            EntityType: 'company',
            Created: moment().unix(),
            Updated: moment().unix(),
        },
    });

    componentDidMount = async () => {
        const view = localStorage.getItem('paymentsView');
        sessionStorage.clear();
        localStorage.clear();
        localStorage.setItem('paymentsView', view);

        this.standardInputAutoFocusRef.current?.focus();

        window.addEventListener('keypress', this.onEnter, false);

        // REFERRALS
        const searchParams = new URLSearchParams(window.location.search);
        const referredBy = searchParams.get('referredBy');
        const referralCode = searchParams.get('referralCode');

        if (referredBy) {
            this.setState({ referredBy });
        }
        if (referralCode) {
            this.setState({ referralCode });
        }
        if (referralCode == Config.keypay_referral_code) {
            this.setState({ keypay: true });
        }
    };

    onEnter = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            if (this.state.loading) return;
            this.handleSignup(e);
        }
    };

    componentWillUnmount = () => {
        window.removeEventListener('keypress', this.onEnter, false);
    };

    createFirstLastName = (fullName, user) => {
        user.FirstName = fullName.shift();
        user.LastName = fullName.join(' ');
        return user;
    };

    handleShowPassword = (flag) => {
        this.setState({ isShowPassword: flag });
    };

    handleShowPasswordConfirm = (flag) => {
        this.setState({ isShowPasswordConfirm: flag });
    };

    handleChange = (event) => {
        const { user, errors } = this.state;
        const {
            target: { name, value },
        } = event;

        user[name] = value;
        if (name === 'Email') user[name] = toLowerCaseSafe(value);

        if (errors[name]) {
            delete errors[name];
        }
        this.setState({ user, errors });
    };

    setMobileCountry = (country, mobile) => {
        this.setState({ country: country, mobile: mobile });
    };

    handleChangePass = (event) => {
        const {
            target: { name, value },
        } = event;
        const { errors } = this.state;
        this.setState({
            [name]: value,
            confirmPassword: value,
        });
        if (errors[name]) {
            delete errors[name];
        }
    };

    handleTerm = (event) => {
        const {
            target: { checked },
        } = event;
        const { errors } = this.state;
        this.setState({ term: checked });

        if (errors.term) {
            delete errors.term;
        }
    };

    setUserType = (type) => {
        this.setState((prevState) => {
            return {
                user: {
                    ...prevState.user,
                    EntityType: type,
                },
            };
        });
    };

    clearForm = () => {
        this.setState(this.getInitialState());
    };

    handleSignup = async (e) => {
        e.stopPropagation();
        e.preventDefault();

        const isValid = await this.isValidation();
        if (!isValid) {
            return false;
        }

        this.setState({ loading: true });
        const { user, password, mobile, country, referralCode } = this.state;
        const { history } = this.props;

        const params = {
            email: user.Email,
            firstName: user.FirstName,
            lastName: user.LastName,
            password,
            mobile,
            country,
            ...(this.state.authFlow && { authFlow: this.state.authFlow.toUpperCase() }),
        };

        //attach keypay referral code if signing up via keypay cobranding
        const searchParams = new URLSearchParams(window.location.search);
        const clientId = searchParams.get('clientId');
        if (clientId && clientId === Config.keypay_client_id) {
            params.referralCode = Config.keypay_referral_code;
        }

        if (referralCode) {
            params.referralCode = referralCode;
        }
        let result;
        try {
            result = await this.context.createUserSignUp(params);
        } catch (e) {
            if (e.response) {
                this.setState({
                    errorMessage: MESSAGES.ERROR_USER_SIGNUP,
                    isError: true,
                    loading: false,
                });
                return false;
            }
            this.setState({
                errorMessage: MESSAGES.ERROR_USER_SIGNUP,
                isError: true,
                loading: false,
            });
            return false;
        }
        if (result) {
            window.dataLayer.push({
                event: 'SignupComplete',
                userId: result?.data?.userId,
            });

            const _hsq = (window._hsq = window._hsq || []);
            const resp = _hsq.push([
                'identify',
                {
                    email: user.Email,
                },
            ]);
            _hsq.push(['setPath', '/signup']);
            _hsq.push(['trackPageView']);

            console.log('resp', resp);

            if (result.status === 201) {
                if (this.state.authFlow?.toUpperCase() === 'NEW') {
                    history(`/verify-email-v2?email=${encodeURIComponent(user.Email)}`);
                } else {
                    history(`/verify-email?userId=${result?.data?.userId}`);
                }
            } else {
                this.setState({
                    errorMessage: result.message ? result.message : MESSAGES.ERROR_USER_SIGNUP,
                    isError: true,
                    loading: false,
                });
                return false;
            }
        }
        return true;
    };

    async isValidation() {
        let errorMessage = '';
        this.setState({ errors: {}, errorMessage });

        const errors = {};
        let isError = false;
        const { password, confirmPassword, user, term, mobile } = this.state;
        const validator = new Validator();

        if (!validator.required(user.FirstName)) {
            errors.FirstName = MESSAGES.ERROR_REQUIRED;
            isError = true;
        }
        if (!validator.vaildName(user.FirstName)) {
            errors.FirstName = MESSAGES.ERROR_INVALID_NAME;
            isError = true;
        }
        if (!validator.required(user.LastName)) {
            errors.LastName = MESSAGES.ERROR_REQUIRED;
            isError = true;
        }
        if (!validator.vaildName(user.LastName)) {
            errors.LastName = MESSAGES.ERROR_INVALID_NAME;
            isError = true;
        }
        if (!validator.required(user.Email)) {
            errors.Email = MESSAGES.ERROR_REQUIRED;
            isError = true;
        } else if (!validator.email(user.Email)) {
            errors.Email = MESSAGES.ERROR_EMAIL;
            isError = true;
        }

        if (!validator.required(mobile)) {
            errors.mobile = MESSAGES.ERROR_NUMBER;
            isError = true;
        }

        if (!validator.minLength(password, 10)) {
            errors.password = MESSAGES.ERROR_PASSWORD;
            errorMessage = MESSAGES.ERROR_PASSWORD_INFO;
            isError = true;
        } else if (!validator.validPassword(password)) {
            errors.password = MESSAGES.ERROR_PASSWORD;
            errorMessage = MESSAGES.ERROR_PASSWORD_INFO;
            isError = true;
        }

        if (!validator.required(confirmPassword)) {
            errors.confirmPassword = MESSAGES.ERROR_REQUIRED;
            isError = true;
        } else if (!validator.match(password, confirmPassword)) {
            errors.confirmPassword = MESSAGES.ERROR_CONFIRM_PASS;
            isError = true;
        }

        if (!term) {
            errors.term = 'Please agree with terms of use';
            isError = true;
        }

        if (!window.navigator.onLine) {
            this.setState({
                errorMessage: MESSAGES.ERROR_NETWORK_CONNECTION,
                isError: true,
            });
            isError = true;
        }

        if (Config.paytronURL === 'https://app.paytron.com.au') {
            try {
                const emailIsValid = await validateEmail({ email: user.Email });
                if (!emailIsValid.isValid) {
                    errors.Email = MESSAGES.ERROR_UNSUPPORTED_EMAIL;
                    isError = true;
                }
            } catch (err) {
                console.error(err);
                errors.Email = MESSAGES.ERROR_UNSUPPORTED_EMAIL;
                isError = true;
            }
        }

        if (isError) {
            this.setState({ errors, errorMessage, isError: true });
            return false;
        }

        return true;
    }

    render() {
        const { user, password, loading, errors, isError, errorMessage, isShowPassword, oAuthLogin, referredBy } =
            this.state;

        return (
            <AuthPageWrapper>
                <div className={classes.form}>
                    <div className={classes.title}>
                        <h2>Create your account</h2>
                        {referredBy && !referredBy.startsWith('PTRN') && (
                            <label className="referral pre-wrap">You've been referred by {referredBy}</label>
                        )}
                    </div>
                    <div className={classes.body}>
                        <Notification
                            isError={isError}
                            message={errorMessage}
                            handleCloseMsg={() => {
                                this.setState({ errorMessage: '' });
                            }}
                        />
                        <div className="name" style={{ display: 'flex' }}>
                            <div
                                className={`form-group${errors.FirstName ? ' form-error' : ''}`}
                                style={{ marginRight: '20px' }}
                            >
                                <TextInput
                                    label="First name"
                                    name="FirstName"
                                    placeholder="Jane"
                                    required
                                    value={user.FirstName}
                                    onChange={this.handleChange}
                                    autoFocus
                                    ref={this.standardInputAutoFocusRef}
                                    errorMessage={errors.FirstName}
                                />
                            </div>
                            <div className={`form-group${errors.LastName ? ' form-error' : ''}`}>
                                <TextInput
                                    label="Last name"
                                    name="LastName"
                                    placeholder="Doe"
                                    required
                                    value={user.LastName}
                                    onChange={this.handleChange}
                                    errorMessage={errors.LastName}
                                    ref={this.inputAutoFocusRef}
                                />
                            </div>
                        </div>
                        <div className={`form-group${errors.Email ? ' form-error' : ''}`}>
                            <TextInput
                                label="Your professional email"
                                name="Email"
                                placeholder="example@company.com"
                                required
                                value={user.Email}
                                onChange={this.handleChange}
                                errorMessage={errors.Email}
                                ref={this.inputAutoFocusRef}
                            />
                        </div>
                        <MobileCountrySelector
                            flexed
                            required
                            getMobileCountry={this.setMobileCountry}
                            mobileError={errors.mobile}
                        />
                        <div className={`form-group${errors.password ? ' form-error' : ''}`}>
                            <label
                                style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    flex: 1,
                                }}
                            >
                                Password
                                <Tooltip showIcon marginLeft={5} hoverText={passwordTooltipText} />
                            </label>
                            <input
                                name="password"
                                type={isShowPassword ? 'text' : 'password'}
                                className="form-control"
                                placeholder="Password"
                                value={password}
                                onChange={this.handleChangePass}
                            />
                            <i
                                className={`i-${isShowPassword ? 'unview' : 'view'}`}
                                onClick={() => this.handleShowPassword(!isShowPassword)}
                            />
                            <InputError error={errors.password} />
                        </div>
                        <div className={classes.formSubmit}>
                            <Button
                                type="primary"
                                text="Get started"
                                id="onboarding_0_getStarted"
                                onClick={this.handleSignup}
                                disabled={loading}
                                loading={loading}
                            />
                            <p style={{ textAlign: 'right', paddingLeft: '10px' }}>
                                Already have an account?
                                {` `}
                                {oAuthLogin ? (
                                    <Link to={`/connect${window.location.search}&signin=true`}>Sign in</Link>
                                ) : (
                                    <Link to="/signin">Sign in</Link>
                                )}
                            </p>
                        </div>
                    </div>
                </div>
                <div className={classes.spacer} />
                <div className={`${classes.bottomLinks} ${classes.signUp}`}>
                    <a href={Config.termConditionUrl} target="_blank" rel="noreferrer">
                        Legals &amp; Privacy
                    </a>
                </div>
            </AuthPageWrapper>
        );
    }
}

export default withRouter(UserSignUp);
